import React from 'react'
import {
  CompensateGridContainer,
  Layout,
  HorizontalDivisor,
  LabelResults,
  LabelResultsContainer,
  YearsResults
} from './styles'
import { PropertyIndicators } from '../PropertyIndicators'
import { CHECK_UP_YEARS_QUANTITY, EMPTY_MEASUREMENT } from '~/constants/checkUp'
import { useCheckUp } from '~/context'
import { CheckUpPropertyMeasurement, ECheckUpPropertyTypes } from '~/interfaces'
import { transformDate } from '~/utils'

const fixPropertyMeasurementLength = (measurements: CheckUpPropertyMeasurement[]): CheckUpPropertyMeasurement[] => {
  const fixedMeasurements = measurements.slice(0, CHECK_UP_YEARS_QUANTITY)

  if (fixedMeasurements.length < CHECK_UP_YEARS_QUANTITY) {
    return fixPropertyMeasurementLength([...fixedMeasurements, EMPTY_MEASUREMENT])
  }
  return fixedMeasurements
}

const getCheckUpMeasurementsGroupByType = (properties: CheckUpPropertyMeasurement[]) => {
  return properties.reduce<Record<string, CheckUpPropertyMeasurement[]>>((accumulator, property) => {
    if (!accumulator[property.type]) {
      accumulator[property.type] = []
    }
    accumulator[property.type].push(property)
    return accumulator
  }, {})
}

const getYearsFromProperties = (properties: CheckUpPropertyMeasurement[]): string[] => {
  return properties.reduce<string[]>((yearsAccumulator, property) => {
    const propertyYear = transformDate({ date: property.date, dateFormat: 'yyyy' })

    if (yearsAccumulator.includes(propertyYear)) return yearsAccumulator
    return [...yearsAccumulator, propertyYear]
  }, [])
}

export const CheckUpGrid = (): JSX.Element => {
  const { checkUpProperties } = useCheckUp()
  const propertiesYears = getYearsFromProperties(checkUpProperties)

  const { [ECheckUpPropertyTypes.METABOLIC_SYNDROME]: metabolicSyndrome, ...previousProperties } =
    getCheckUpMeasurementsGroupByType(checkUpProperties)

  const orderedMetabolicSyndrome = fixPropertyMeasurementLength(metabolicSyndrome)
  const orderedPreviousProperties = Object.values(previousProperties).map(property =>
    fixPropertyMeasurementLength(property)
  )

  return (
    <Layout>
      <LabelResultsContainer>
        <CompensateGridContainer />
        <YearsResults>{propertiesYears?.map(year => <LabelResults key={year}>{year}</LabelResults>)}</YearsResults>
        <LabelResults>Prob. de alteração</LabelResults>
      </LabelResultsContainer>

      {orderedPreviousProperties.map(property => (
        <PropertyIndicators key={property[0].type} property={property} />
      ))}
      <HorizontalDivisor />
      <PropertyIndicators property={orderedMetabolicSyndrome} />
    </Layout>
  )
}
